export default __webpack_public_path__ + "static/media/blind-vip.54798850.svg";